import { CohortNames } from '@bridebook/toolbox/src/ab-testing/lib/types';
import { CountryCodes, Market } from '@bridebook/toolbox/src/gazetteer';
import { LandingPageIds } from '@bridebook/web/lib/landing/webflow-page-urls';

/**
 * Object defining AB tests for landing pages, with different webflow paths for page variants
 *
 * IF NO TESTS AT THE MOMENT, LEAVE AN EMPTY OBJECT
 *
 * Example:
 *   [LandingPageIds.localeHome]: {
 *     testId: 'LIVE-20349_HomepageHeroImage',
 *     markets: [CountryCodes.GB],
 *     variantPaths: (market) => ({
 *       '1': `${market.prefix}/home-test-a`,
 *       '2': `${market.prefix}/home-test-b`,
 *       '3': `${market.prefix}/home-test-c`,
 *     }),
 *   }
 */
export const LandingPagesTests: Partial<
  Record<
    LandingPageIds,
    {
      // Test id from Firestore
      testId: string;
      // Paths to webflow pages of different variants. Do not include a forward slash.
      // Path to control version is taken from `WebflowLandingPages` object.
      variantPaths: (market: Market) => Partial<Record<Exclude<CohortNames, 'control'>, string>>;
      // Limit AB test only for specific markets
      markets?: CountryCodes[];
    }
  >
> = {};
